import AddIcon from "@mui/icons-material/Add";
import { Grid } from "@mui/material";
import { Button, SelectInput, TextInput, required, useNotify, useRecordContext, useRefresh } from "react-admin";
import FormModal from "server/components/Modals/FormModal";
import CustomDateInput from "server/components/Fields/CustomDateInput";
import dataProvider from "server/dataProvider";
import { doctoralRequests } from "api/doctoralApi";
import { DoctorantReportProtocolTypeChoices, DoctorantReportStatusChoices } from "utils/choices";
import { validateDateNotInFuture } from "utils/validations";

const AddReportDialog = () => {
  const record = useRecordContext();
  const notify = useNotify();
  const refresh = useRefresh();

  if (!record?.id) return null;

  const handleConfirm = async data => {
    await dataProvider.customRequest(
      doctoralRequests.addDoctorantReport(record.id),
      {
        protocolType: data.protocolType,
        protocolDate: data.protocolDate,
        protocolNumber: data.protocolNumber,
        status: data.status,
      },
      "POST",
    );
    notify("Отчетът е добавен успешно", { type: "success" });
    refresh();
  };

  return (
    <FormModal
      titleContent="Добавяне на отчет"
      saveTitle="Добави"
      dialogSize="md"
      onConfirm={handleConfirm}
      triggerButton={
        <Button
          label="Добави отчет"
          variant="contained"
          startIcon={<AddIcon />}
        />
      }
    >
      <Grid
        container
        spacing={2}
        sx={{ mt: 0 }}
      >
        <Grid
          item
          xs={12}
          md={6}
        >
          <SelectInput
            source="protocolType"
            label="Вид отчет"
            choices={DoctorantReportProtocolTypeChoices}
            validate={required("Задължително")}
            fullWidth
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <CustomDateInput
            source="protocolDate"
            label="Дата на протокола"
            validate={[required("Задължително"), validateDateNotInFuture]}
            maxDate={new Date()}
            noTime
            fullWidth
            required
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <TextInput
            source="protocolNumber"
            label="Номер на протокола"
            validate={required("Задължително")}
            fullWidth
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <SelectInput
            source="status"
            label="Статус"
            choices={DoctorantReportStatusChoices}
            validate={required("Задължително")}
            fullWidth
          />
        </Grid>
      </Grid>
    </FormModal>
  );
};

export default AddReportDialog;
